export default __webpack_public_path__ + "static/media/exitIcon.6eac7566.svg";